import { api } from '../client';

export const fetchFooter = async () => {
  const { data } = await api.get('/footer');
  return data;
};
